import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { MessageCircleIcon } from 'lucide-react';
import { useMarketplace } from '../contexts/MarketplaceContext';
import { Button } from './ui/Button';
import { easeOut, spring } from '../utils/motion';
const rays = Array.from({
  length: 12
}, (_, i) => i * 30);
export function MatchOverlay() {
  const {
    celebration,
    setCelebration,
    getEvent,
    getPerformer
  } = useMarketplace();
  const navigate = useNavigate();
  const {
    pathname
  } = useLocation();
  const event = celebration ? getEvent(celebration.eventId) : undefined;
  const performer = celebration ? getPerformer(celebration.performerId) : undefined;
  const close = () => setCelebration(null);
  useEffect(() => {
    if (!celebration) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setCelebration(null);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [celebration, setCelebration]);
  const openChat = () => {
    if (!celebration) return;
    const base = pathname.startsWith('/o') ? '/o' : '/p';
    navigate(`${base}/messages/${celebration.id}`);
    close();
  };
  return <AnimatePresence data-id="element-452" data-mp="2cwic40pxn3u2">
      {celebration && event && performer && <motion.div role="dialog" aria-modal="true" aria-labelledby="match-title" className="fixed inset-0 z-[80] grid place-items-center bg-black/80 px-6 text-white backdrop-blur-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: 'easeOut'
    }} onClick={close} data-id="element-453" data-mp="2cx9vmd699b3z">
          <div className="flex w-full max-w-sm flex-col items-center text-center" onClick={e => e.stopPropagation()} data-id="element-454" data-mp="1u45y2gpx2e43">
            <div className="relative grid h-48 w-full place-items-center" data-id="element-455" data-mp="11hl6pg9fy20j">
              {rays.map((deg, i) => <motion.span key={deg} className="absolute left-1/2 top-1/2 h-24 w-1.5 origin-bottom rounded-full bg-accent" style={{
            rotate: deg,
            x: '-50%',
            y: '-100%'
          }} initial={{
            scaleY: 0.2,
            opacity: 0
          }} animate={{
            scaleY: [0.2, 1, 1],
            opacity: [0, 1, 0]
          }} transition={{
            duration: 0.75,
            delay: 0.12 + i * 0.012,
            ease: easeOut
          }} data-id="element-456" data-mp="1r6a825kcoqxm" data-mpi={i} />)}
              <div className="relative flex items-center" data-id="element-457" data-mp="1c7y9tuhbxa4c">
                <motion.img src={performer.photos[0]} alt={performer.name} className="h-32 w-32 rounded-full border-4 border-white object-cover" initial={{
              x: -110,
              rotate: -24,
              opacity: 0
            }} animate={{
              x: 14,
              rotate: -6,
              opacity: 1
            }} transition={spring.bouncy} data-id="element-458" data-mp="1c8huvk2a0eml" />
                <motion.img src={event.photos[0]} alt={event.name} className="h-32 w-32 rounded-full border-4 border-white object-cover" initial={{
              x: 110,
              rotate: 24,
              opacity: 0
            }} animate={{
              x: -14,
              rotate: 6,
              opacity: 1
            }} transition={spring.bouncy} data-id="element-459" data-mp="2xjzoxfahcexs" />
              </div>
            </div>
            <motion.h2 id="match-title" className="mt-2 text-5xl font-bold tracking-[-0.02em]" initial={{
          scale: 0.96,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          ...spring.bouncy,
          delay: 0.1
        }} data-id="element-460" data-mp="791govzb3vx4">
              It’s a match
            </motion.h2>
            <p className="mt-3 text-[17px] text-white/80" data-id="element-461" data-mp="3kgczq3bb7g19">
              {performer.name} × {event.name}
            </p>
            <div className="mt-8 flex w-full flex-col gap-3" data-id="element-462" data-mp="1nm9r9dv5ek2j">
              <Button variant="accent" size="lg" fullWidth icon={<MessageCircleIcon className="h-5 w-5" data-id="element-464" data-mp="1iozs36hyiu1i" />} onClick={openChat} data-id="element-463" data-mp="1ioq2hk0tqowc">
                Send a message
              </Button>
              <button type="button" onClick={close} className="h-12 rounded-full font-bold text-white/85 transition-colors duration-150 hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-465" data-mp="1qnbf91o1bzn7">
                Keep swiping
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}